import { useState } from "react";
import "./advert.css";
import { db } from "../../firebase";
import { collection, addDoc, Timestamp } from "firebase/firestore";

export default function Ilan() {
  const [marka, setMarka] = useState("");
  const [product, setProduct] = useState("");
  const [participate, setParticipate] = useState("");
  const [details, setDetails] = useState("");
  const [address, setAddress] = useState("");
  const [title, setTitle] = useState("");
  const [par, setPar] = useState("");
  const [notes, setNotes] = useState("");
  const [minFollowers, setMinFollowers] = useState("");
  const [subject, setSubject] = useState("");
  const [minPay, setMinPay] = useState("");
  const [maxPay, setMaxPay] = useState("");
  const [gender, setGender] = useState("");
  const [productSend, setProductSend] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, "ilanlar"), {
        marka: marka,
        product: product,
        participate: participate,
        details: details,
        address: address,
        title: title,
        par: par,
        notes: notes,
        minFollowers: minFollowers,
        subject: subject,
        minPay: minPay,
        maxPay: maxPay,
        gender: gender,
        productSend: productSend,
        created: Timestamp.now(),
      });
    } catch (err) {
      console.log(err.message);
    }
  };
  return (
    <div className="ilan">
      <h1 className="newUserTitle">İlan Ekle</h1>
      <form onSubmit={handleSubmit} className="newUserForm">
        <div className="newUserItem">
          <label>Marka Adı</label>
          <input
            type="text"
            required
            onChange={(e) => setMarka(e.target.value)}
          />
        </div>
        <div className="newUserItem">
          <label>Ürün Adı</label>
          <input
            type="text"
            required
            onChange={(e) => setProduct(e.target.value)}
          />
        </div>
        <div className="newUserItem">
          <label>Katılım Şartları</label>
          <input
            type="text"
            required
            onChange={(e) => setParticipate(e.target.value)}
          />
        </div>
        <div className="newUserItem">
          <label>Proje Detayları</label>
          <input
            type="text"
            required
            onChange={(e) => setDetails(e.target.value)}
          />
        </div>
        <div className="newUserItem">
          <label>Adres</label>
          <input
            type="text"
            required
            onChange={(e) => setAddress(e.target.value)}
          />
        </div>
        <div className="newUserItem">
          <label>Üst Metin</label>
          <input
            type="text"
            required
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>
        <div className="newUserItem">
          <label>Alt Metin</label>
          <input
            type="text"
            required
            onChange={(e) => setPar(e.target.value)}
          />
        </div>
        <div className="newUserItem">
          <label>Notlar</label>
          <input
            type="text"
            required
            onChange={(e) => setNotes(e.target.value)}
          />
        </div>
        <div className="newUserItem">
          <label>Minimum Takipçi Sayısı</label>
          <input
            type="number"
            required
            onChange={(e) => setMinFollowers(e.target.value)}
          />
        </div>
        <div className="newUserItem">
          <label>İçerik Türü</label>
          <input
            type="number"
            required
            onChange={(e) => setSubject(e.target.value)}
          />
        </div>
        <div className="newUserItem">
          <label>Minimum Ücret</label>
          <input
            type="text"
            min="0"
            required
            onChange={(e) => setMinPay(e.target.value)}
          />
        </div>
        <div className="newUserItem">
          <label>Maksimum Ücret</label>
          <input
            type="text"
            min="0"
            required
            onChange={(e) => setMaxPay(e.target.value)}
          />
        </div>
        <div className="newUserItem">
          <label>Cinsiyet</label>
          <div className="newUserGender">
            <input
              type="checkbox"
              name="gender"
              id="male"
              value="male"
              onChange={(e) => setGender(e.target.value)}
            />
            <label for="male">Kadın</label>
            <input
              type="checkbox"
              name="gender"
              id="female"
              value="female"
              onChange={(e) => setGender(e.target.value)}
            />
            <label for="female">Erkek</label>
          </div>
        </div>

        <div className="newUserItem">
          <label>Ürün Gönderimi</label>
          <div className="newUserGender">
            <input
              type="radio"
              name="gender"
              id="male"
              onChange={(e) => setMaxPay(e.target.value)}
            />
            <label for="male">Var</label>
            <input
              type="radio"
              name="gender"
              id="female"
              onChange={(e) => setMaxPay(e.target.value)}
            />
            <label for="female">Yok</label>
          </div>
        </div>

        <button type="submit" className="newUserButton">
          Ekle
        </button>
      </form>
    </div>
  );
}
